import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ToggledependencyComponent } from '../toggledependency/toggledependency.component';
import { EditbuttonrenderComponent } from '../editbuttonrender/editbuttonrender.component';
import { CommonService } from 'src/app/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { DynamicpopupComponent } from '../dynamicpopup/dynamicpopup.component';
import { param } from 'jquery';
import { MatSnackBar } from '@angular/material/snack-bar';
let vm: any;
@Component({
  selector: 'app-definedoctype',
  templateUrl: './definedoctype.component.html',
  styleUrls: ['./definedoctype.component.scss']
})
export class DefinedoctypeComponent implements OnInit {
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
  overlayNoRowsTemplate = '<span class="ag-overlay-no-rows-center">No data available</span>';
  rowSelection = 'multiple';
  rowHeight = 30;
  gridApi: any;
  gridColumnApi: any;
  tooltipShowDelay = 0;
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.sizeColumnsToFit();

  }
  frameworkComponents = {
    editButtonRederer: EditbuttonrenderComponent,
  }
  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    minWidth: 110
  };
  rowData = [];
  columnDefs: any = [
    {
      headerName: "Doc Type ID", field: "lookup_id", headerTooltip: "Doc Type ID", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Doc Type", field: "lookup_code", headerTooltip: "Doc Type", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Visibility", field: "visibility", headerTooltip: "Visibility", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Created on", field: "created_on", headerTooltip: "Created on", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },
    {
      headerName: "Status", field: "enabled_flag", headerTooltip: "Status", pinned: 'right',
      cellRendererFramework: ToggledependencyComponent,
      cellRendererParams: {
        clicked: function (params: any) {
          console.log("params", params)
          alert("gtyy")
          this._snackBar.open('Status Change Successfully', "Close",
            { verticalPosition: 'top', horizontalPosition: 'center', });

          vm.changestatus(params.data);
        },
      }
    }
    , {
      headerName: "Edit", field: "edit", headerTooltip: "Edit", pinned: 'right', cellRenderer: 'editButtonRederer',

      cellRendererParams: {
        clicked: function (params: any) {
          console.log("params", params)
          vm.openEditpop(params.data);
        },
      }
    },
    {
      headerName: "Logs", field: "logs", headerTooltip: "Logs", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    }

  ]
  constructor(private commonServ: CommonService, private dialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    vm = this;
    this.fetchDocumenttypetabledata();
  }
  onCellClicked(item) { }

  changestatus(event) {
    console.log("event", event)
    alert("rrt")
    this._snackBar.open('Status Change Successfully', "Close",
      { verticalPosition: 'top', horizontalPosition: 'center', });
  }
  fetchDocumenttypetabledata() {
    this.commonServ.fetchDocumenttypetabledata().subscribe((response) => {
      console.log("fetchDocumenttypetabledata", response)
      this.rowData = response
    })
  }

  openEditpop(row: any) {
    console.log('editpop', row)
    console.log("rowdatatest", this.rowData)
    const dialogRef = this.dialog.open(DynamicpopupComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: 'Edit Doc Types',
        type: 'editDocTypes',
        param: row,
        tabledata: this.rowData
      },
      panelClass: 'my-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      console.log("new1")
      this.ngOnInit()
      if (data) {

      }
    });
  }

  createNewDoctype() {
    const dialogRef = this.dialog.open(DynamicpopupComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: 'Add New Doc Type',
        type: 'defineDocTypes',
        tabledata: this.rowData
      },
      panelClass: 'my-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      console.log("new1")
      this.ngOnInit()
      if (data) {

      }
    });
  }

}
